import { useContext } from "react";
import { UUID } from "crypto";
import { NawyPassportContext } from "@/modules/common/context/nawy-passport.provider";
import { userHasPermission } from "@/modules/common/utils";
import { PermissionLevel, PermissionsEnum } from "@/modules/common/types";
import PermissionGuard from "@/modules/common/components/wrappers/permission-guard";
import ResponsiveModal from "@/modules/common/components/ui-kit/modals/responsive-modal";
import EditAd from "@/modules/lead-page/components/lead-info/edit-fields/ad";
import LeadInfoField from "@/modules/lead-page/new/components/lead-info-field";
import useLeadInfo from "@/modules/lead-page/hooks/lead-info/lead-info.hook";
import FieldWrapper from "@/modules/lead-page/new/components/sidebar/fields/field-wrapper";

const AdField = () => {
  const { ad, isLoading, handleConfirmUpdate } = useLeadInfo();
  const { permissions: currentUserPermissions } =
    useContext(NawyPassportContext);

  return (
    <LeadInfoField
      editable={userHasPermission(
        {
          name: PermissionsEnum.EDIT_JOURNEY_CAMPAIGN_DETAILS,
          level: PermissionLevel.WRITE,
        },
        currentUserPermissions
      )}
      sxInnerBox={{
        justifyContent: "space-between",
      }}
      content={ad.value || "Not Set"}
      setEditModalOpen={ad.setEditAdModalOpen}
      editModalOpen={ad.editAdModalOpen}
      editModal={
        <PermissionGuard
          permissions={[
            {
              name: PermissionsEnum.EDIT_JOURNEY_CAMPAIGN_DETAILS,
              level: PermissionLevel.WRITE,
            },
          ]}
        >
          <ResponsiveModal
            open={ad.editAdModalOpen}
            onClose={() => {
              ad.setEditAdModalOpen(false);
              ad.setState(null);
            }}
            title="Edit Ad"
            confirmButtonText="Save"
            cancelButtonText="Cancel"
            onConfirm={() => {
              handleConfirmUpdate({
                lead: {
                  adUId: ad.state?.uid as UUID,
                },
              });
              ad.setState(null);
            }}
            isLoading={isLoading}
            isConfirmDisabled={!ad.state}
            snapPoints={[1]}
          >
            <FieldWrapper>
              <EditAd ad={ad} />
            </FieldWrapper>
          </ResponsiveModal>
        </PermissionGuard>
      }
    />
  );
};

export default AdField;
